import { CheckCircle, RadioButtonUnchecked, SelectAll } from '@mui/icons-material';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import type { GenericModule } from "@/api/module.service";

interface GlobalModuleActionsProps {
  selectedCompaniesData: { id: string; name: string }[];
  clientModules: GenericModule[];
  onModulesChange: (companyId: string, moduleIds: string[]) => void;
}

const GlobalModuleActions = ({
  selectedCompaniesData,
  clientModules,
  onModulesChange,
}: GlobalModuleActionsProps) => {
  const handleGlobalAction = (action: 'select' | 'unselect') => {
    const newModuleIds = action === 'select' ? clientModules.map(m => m.id) : [];
    selectedCompaniesData.forEach(company => onModulesChange(company.id, newModuleIds));
  };

  if (!selectedCompaniesData.length) return null;

  return (
    <Paper
      variant="outlined"
      sx={{
        mb: 2,
        px: 2.5,
        py: 1.5,
        bgcolor: 'primary.main',
        borderColor: 'primary.dark',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <SelectAll sx={{ color: 'primary.contrastText', fontSize: 20 }} />
        <Typography
          sx={{ fontWeight: 600, color: 'primary.contrastText', fontSize: '0.9rem' }}
        >
          Marcar todas as empresas ({selectedCompaniesData.length})
        </Typography>
      </Box>

      <Stack direction="row" spacing={1}>
        <Button
          size="small"
          variant="outlined"
          onClick={() => handleGlobalAction('select')}
          startIcon={<CheckCircle />}
          sx={{
            textTransform: 'none',
            fontSize: '0.75rem',
            color: 'primary.contrastText',
            borderColor: 'rgba(255,255,255,0.5)',
            '&:hover': {
              borderColor: 'primary.contrastText',
              bgcolor: 'rgba(255,255,255,0.1)',
            },
          }}
        >
          Todos
        </Button>

        <Button
          size="small"
          variant="outlined"
          onClick={() => handleGlobalAction('unselect')}
          startIcon={<RadioButtonUnchecked />}
          sx={{
            textTransform: 'none',
            fontSize: '0.75rem',
            color: 'primary.contrastText',
            borderColor: 'rgba(255,255,255,0.5)',
            '&:hover': {
              borderColor: 'primary.contrastText',
              bgcolor: 'rgba(255,255,255,0.1)',
            },
          }}
        >
          Nenhum
        </Button>
      </Stack>
    </Paper>
  );
};

export default GlobalModuleActions;
